/**
 * Shift Repository
 * Fetches shifts for dropdowns (e.g. User Rota)
 */

import { apiClient } from '../client'

export interface Shift {
    id: number
    tenant_id?: number
    name: string
    ar_name: string;
    from?: string
    to?: string
    is_time_restricted?: number;
    status?: number
    created_by?: number | null
    updated_by?: number | null
}

export interface CreateShiftRequest {
    name: string
    ar_name: string;
    from?: string | null
    to?: string | null
    is_time_restricted?: number;
    status?: number
    tenant_id?: number
}

class ShiftRepository {
    async getAll(): Promise<Shift[]> {
        return apiClient.get<Shift[]>('/shifts')
    }

    async getById(id: number): Promise<Shift> {
        return apiClient.get<Shift>(`/shifts/${id}`)
    }

    async create(data: CreateShiftRequest): Promise<Shift> {
        return apiClient.post<Shift>('/shifts', data)
    }

    async update(id: number, data: Partial<CreateShiftRequest>): Promise<Shift> {
        return apiClient.put<Shift>(`/shifts/${id}`, data)
    }

    async delete(id: number): Promise<{ message: string }> {
        return apiClient.delete<{ message: string }>(`/shifts/${id}`)
    }
}

export const shiftRepository = new ShiftRepository()
